import React, { useState } from "react";
import { ReactTitle } from "react-meta-tags";
import { useTranslation } from "react-i18next";

import Admissions from "./contents/admissions";
import Tabs from "../tableProvider/tabs";
import MainTemplate from "../mainTemplate";
import ApprovalProvider from "./contents/providers";
import InvitationApproval from "./contents/invitations";
import { getRoles } from "../../../Redux/reducer/session";
import { moduleAction } from "../../utils/functions";
import { EXECUTE, MOD_DISCONT_PROV, MOD_PROVID } from "../../../permissions";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";

const Admision = () => {
  const [state, setState] = useState({
    filterItems: undefined,
    filterSearch: undefined,
  });

  const roles = useSelector(getRoles);
  const { t } = useTranslation();

  const setFilters = ({ filterItems, filterSearch }) => {
    setState({ filterItems, filterSearch });
  };

  const modDiscontPermissions = moduleAction(roles, MOD_DISCONT_PROV, EXECUTE);

  const getTabItems = () => {
    let items = [];

    if (moduleAction(roles, MOD_PROVID, EXECUTE) || modDiscontPermissions) {
      items.push(
        <div key={`suppliers-tab`} label={t("admissions.tabs.suppliers")}>
          <ApprovalProvider setFilters={setFilters} />
        </div>
      );
    }

    if (modDiscontPermissions) {
      items.push(
        <div key={`invitations-tab`} label={t("admissions.tabs.invitations")}>
          <InvitationApproval setFilters={setFilters} />
        </div>
      );
    }

    if (modDiscontPermissions) {
      items.push(
        <div key={`admission-tab`} label={t("admissions.tabs.admissions")}>
          <Admissions setFilters={setFilters} />
        </div>
      );
    }

    return items;
  };

  const { filterItems, filterSearch } = state;
  const activeTab =
    new URLSearchParams(useLocation().search).get("page") === "modifications"
      ? t("admissions.tabs.admissions")
      : "";

  return (
    <MainTemplate>
      <ReactTitle title={`${t("admissions.meta.title")} - ${t("appName")}`} />
      <div id="approvals">
        <div className="tabs-admissions">
          <Tabs
            filterItems={filterItems}
            filterSearch={filterSearch}
            activeTab={activeTab}
          >
            {getTabItems()}
          </Tabs>
        </div>
      </div>
    </MainTemplate>
  );
};

export default Admision;
